var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasAnyGroup || _vm.$slots['no-groups'])?_c('span',[(_setup.hasAnyGroup)?_vm._t("default"):_vm._t("no-groups")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }